export const API_HOST = window._env_?.apiHost || "https://api.natif.ai";
